export default __webpack_public_path__ + "static/media/185.73476d53.png";